import { Grid, ListItem, Tooltip, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    listItemContainer: {
      // borderLeftStyle: 'solid',
      // borderLeftWidth: 4,
    },
  }),
);

interface OccurrencesListItemProps {
  title: string;
  tooltipText?: string;
  show?: boolean;
  mainText: string | number | undefined;
  descriptionText?: string;
  color?: 'error' | 'warning' | 'default' | 'success';
  loading: boolean;
  onClick?: () => void;
}

const OccurrencesListItemSkeleton: React.FC = () => (
  <Grid container spacing={1}>
    <Grid item xs={12}>
      <Skeleton animation="wave" variant="rect" width={40} height={32} />
    </Grid>
    <Grid item xs={12}>
      <Skeleton animation="wave" variant="rect" width="70%" height={22} />
    </Grid>
  </Grid>
);

const OccurrencesListItem: React.FC<OccurrencesListItemProps> = ({
  title,
  show = true,
  mainText,
  descriptionText,
  color = 'default',
  tooltipText,
  loading,
  onClick,
}) => {
  const classes = useStyles();

  // const getColor = (
  //   color: 'error' | 'warning' | 'default' | 'success',
  // ): string => {
  //   switch (color) {
  //     case 'error':
  //       return theme.palette.primary.main;
  //     case 'warning':
  //       return theme.palette.warning.main;
  //     case 'success':
  //       return theme.palette.success.main;

  //     default:
  //       return theme.palette.grey[400];
  //   }
  // };
  return (
    <>
      {show && (
        <ListItem
          divider
          className={classes.listItemContainer}
          onClick={onClick}
          button
          // style={{
          //   borderLeftColor: getColor(loading ? 'default' : color),
          // }}
        >
          <Grid container alignItems="center">
            <Grid container item xs={11}>
              <Grid item xs={12}>
                <Typography color="textSecondary" variant="subtitle1">
                  {title}
                  {tooltipText && (
                    <Tooltip title={tooltipText} placement="right" arrow>
                      <HelpOutlineIcon color="disabled" />
                    </Tooltip>
                  )}
                </Typography>
              </Grid>

              {loading ? (
                <OccurrencesListItemSkeleton />
              ) : (
                <>
                  <Grid item xs={12}>
                    <Typography color="textPrimary" variant="h5">
                      {mainText}
                    </Typography>
                  </Grid>
                  {descriptionText && (
                    <Grid item xs={12}>
                      <Typography color="textSecondary" variant="subtitle1">
                        {descriptionText}
                      </Typography>
                    </Grid>
                  )}
                </>
              )}
            </Grid>

            {!!onClick && (
              <Grid item xs={1}>
                <ChevronRightIcon color="disabled" />
              </Grid>
            )}
          </Grid>
        </ListItem>
      )}
    </>
  );
};

export default OccurrencesListItem;
